import { render, staticRenderFns } from "./InitiateRegistration.vue?vue&type=template&id=6eb46392&"
import script from "./InitiateRegistration.vue?vue&type=script&lang=js&"
export * from "./InitiateRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports